import { IData } from "./BulkSiloUtils";

export type IHandleAllSiloOrderInfo = (
    id: number,
    index: number,
    field: "keyword" | "date" | "anchor",
    value: string
) => void;

export interface ISiloOrderInfoFrom {
    data: IData[];
}
const AllSiloOrderInfoFrom = ({ data }: ISiloOrderInfoFrom) => {
    return (
        <>
            {data.map((el, index) => {
                return (
                    <div className="ml-4" key={index}>
                        <b>{el.url}</b>
                        <ul>
                            {el.allKeywords?.map((keyword, kwIndex) => (
                                <li key={kwIndex}>{keyword}</li>
                            ))}
                        </ul>
                    </div>
                );
            })}
        </>
    );
};

export default AllSiloOrderInfoFrom;
